package org.dronda.app.web.client

import com.github.michaelbull.result.Err
import com.github.michaelbull.result.Ok
import com.github.michaelbull.result.Result
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.delete
import io.ktor.client.request.get
import io.ktor.http.HttpStatusCode
import kotlinx.serialization.Serializable
import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid

@OptIn(ExperimentalUuidApi::class)
class LocationSharingClient(
    private val client: HttpClient
) {

    suspend fun fetchLocationSharingFriends(): Result<List<LocationFriendResponse>, Unit> {
        val response = client.get("location/friends")

        return if (response.status == HttpStatusCode.OK) {
            Ok(response.body())
        } else {
            Err(Unit)
        }
    }

    suspend fun deleteLocationSharingFriend(friendId: Uuid): Result<Unit, Unit> {
        val response = client.delete("location/friend/$friendId")

        return if (response.status == HttpStatusCode.OK) {
            Ok(response.body())
        } else {
            Err(Unit)
        }
    }
}

@OptIn(ExperimentalUuidApi::class)
@Serializable
data class LocationFriendResponse(
    val id: Uuid,
    val email: String,
)
